<template>
  <div>
    <!-- dekstop -->
    <div class="d-none d-sm-block">
      <b-row>
        <b-col>
          <h6>Booking ID</h6>
          <span>{{ order_id }}</span>
        </b-col>
      </b-row>

      <hr style="border-top: 2px solid #dddddd;">

      <b-row>
        <b-col>
          <h6>{{ service_text }}</h6>
          <span>{{ country_text }}, {{ city_text }}</span>
          <br>
          <span v-if="duration === 1">{{ start_date }} ({{ duration }} Day)</span>
          <span v-else>{{ start_date }} - {{ end_date }} ({{ duration }} Days)</span>
        </b-col>
      </b-row>

      <hr v-if="array_of_pax.length > 0" style="border-top: 2px solid #dddddd;">

      <b-row v-if="array_of_pax.length > 0">
        <b-col>
          <h6>Traveller<span v-if="array_of_pax.length > 1">(s)</span></h6>
          <ul>
            <li v-for="(pax, i) in array_of_pax" :key="i">
              {{ pax.first_name }} {{ pax.last_name }} ({{ pax.gender === 'male' ? 'M' : 'F' }})
            </li>
          </ul>
        </b-col>
      </b-row>
    </div>

    <!-- mobile -->
    <div class="d-block d-sm-none">
      <b-row>
        <b-col>
          <h6>Booking ID</h6>
          <span>{{ order_id }}</span>
        </b-col>
      </b-row>

      <hr style="border-top: 2px solid #dddddd;">

      <b-row>
        <b-col>
          <h6>{{ service_text }}</h6>
          <span>{{ country_text }}, {{ city_text }}</span>
          <br>
          <span v-if="duration === 1">{{ start_date }} ({{ duration }} Day)</span>
          <span v-else>{{ start_date }} - {{ end_date }} ({{ duration }} Days)</span>
        </b-col>
      </b-row>

      <hr v-if="array_of_pax.length > 0" style="border-top: 2px solid #dddddd;">

      <b-row v-if="array_of_pax.length > 0">
        <b-col>
          <h6>Traveller<span v-if="array_of_pax.length > 1">(s)</span></h6>
          <ul>
            <li v-for="(pax, i) in array_of_pax" :key="i">
              {{ pax.first_name }} {{ pax.last_name }} ({{ pax.gender === 'male' ? 'M' : 'F' }})
            </li>
          </ul>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// external dependencies
import moment from 'moment'
import swal from 'sweetalert'

// custom component

// api call
import OrderAPI from '@/api/OrderAPI'
import OrderPaxAPI from '@/api/OrderPaxAPI'

export default {
  name: 'Pay_OrderSummary',
  props: ['tgbs_order_id'],
  created: function () {
    if (this.tgbs_order_id) this.getOrderDetail(this.tgbs_order_id)
  },
  data () {
    return {
      order_id: '',
      service_text: '',
      country_text: '',
      city_text: '',
      start_date: '',
      end_date: '',
      duration: '',
      array_of_pax: []
    }
  },
  methods: {
    // yang dibutuhin oleh component ini:
    // order ID
    // nama service
    // country city
    // start_date, end_date & duration
    // array of pax (first_name & last_name)

    // semua data nya bisa didapat dari ObjectID nya Order

    // PREREQUISITES
    getOrderDetail: function (_id) {
      this.orderFetchByParam({
        select: 'order_id start_date end_date duration sgms_country_id sgms_service_id',
        query: {
          is_delete: false,
          _id: _id
        }
      })

      this.orderPaxFetchByParam({
        select: 'first_name last_name gender tgbs_order_id',
        query: {
          is_delete: false,
          tgbs_order_id: _id
        }
      })
    },
    // END PREREQUISITES

    // HTTP REQUEST
    orderFetchByParam: async function (param) {
      try {
        const x = await OrderAPI.fetchByParam(param)
        let fetched = x.data.orders[0]

        // set data from DB
        this.order_id = fetched.order_id
        this.service_text = fetched.service_text
        this.country_text = fetched.country_text
        this.city_text = fetched.city_text
        this.start_date = moment(fetched.start_date).format('ll')
        this.end_date = moment(fetched.end_date).format('ll')
        this.duration = fetched.duration
      } catch (error) {
        swal({
          title: 'Whoops!',
          text: 'We encounter some error in our system, please try again later',
          icon: 'danger',
          button: {
            text: 'Ok'
          }
        })
      }
    },
    orderPaxFetchByParam: async function (param) {
      try {
        const xx = await OrderPaxAPI.fetchByParam(param)
        this.array_of_pax = xx.data.orderpaxs
      } catch (error) {
        swal({
          title: 'Whoops!',
          text: 'We encounter some error in our system, please try again later',
          icon: 'danger',
          button: {
            text: 'Ok'
          }
        })
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Pay/OrderSummary/OrderSummary.vue